import { render, staticRenderFns } from "./MatchDetailRulesSection.vue?vue&type=template&id=f1c6e242&scoped=true"
import script from "./MatchDetailRulesSection.vue?vue&type=script&lang=js"
export * from "./MatchDetailRulesSection.vue?vue&type=script&lang=js"
import style0 from "./MatchDetailRulesSection.vue?vue&type=style&index=0&id=f1c6e242&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c6e242",
  null
  
)

export default component.exports